/**
 * Rutas internas que NO deben indexarse (noindex) ni aparecer en el sitemap.
 * Fuente de verdad compartida entre RobotsService (meta noindex),
 * el generador de sitemap del servidor y el script generate-robots.js.
 *
 * Los segmentos que empiezan con ":" son parámetros y matchean cualquier valor
 * (p. ej. 'blog/categoria/:id' excluye '/blog/categoria/123').
 */
export const EXCLUDED_INDEX_ROUTES: string[] = [
  'home',
  'blog/categoria/:id',
  'verificando-firma',
  'ops/dashboard',
  'rates',
  '4B6XN8K2H7VY3W9M5Q1Z9A3JN7M5D1H8S4L0F2K',
  'mis-procesos',
  'portal/login',
  'portal/dashboard',
  'validar-identidad',
  'confirmar-datos-truora',
  'validacion-interna-proceso',
  'informacion-en-revision',
  'sube-tus-documentos',
  'asegura-tu-tasa',
  'transfiere-el-dinero',
  'sube-el-comprobante-de-pago',
  'firma-los-documentos',
  'cdt-completado',
  'continuar-proceso',
  'no-podemos-continuar-con-tu-proceso',
  'firma-los-documentos-en-fisico',
  'jumbo-cdt',
  'datos-personales',
  'datos-financieros',
  'consulta-en-listas',
  'preguntas-bancamia',
  'preguntas-ban100',
  'preguntas-bancow',
  'preguntas-bancomundomujer',
  'preguntas-mibanco',
  'preguntas-coltefinanciera',
  'preguntas-credifamilia',
  'preguntas-iris',
  'preguntas/coltefinanciera/flamingo',
  'preguntas-cdturbo',
  'cuentanos-sobre-ti',
  'v2/preguntas-cdturbo',
  'v2/datos-personales',
  'v2/datos-financieros',
  'v2/preguntas-bancamia',
  'v2/preguntas-ban100',
  'v2/preguntas-bancow',
  'v2/preguntas-bancomundomujer',
  'v2/preguntas-mibanco',
  'v2/preguntas-coltefinanciera',
  'v2/preguntas-credifamilia',
  'v2/preguntas-iris',
  'v2/preguntas/coltefinanciera/flamingo',
  'v2/preguntas-koa',
  'confirma-tus-datos',
  'bienvenida-usuario-retorno',
  'orden-inversion',
  'cancelacion',
  'vinculacion-ban100',
  'vinculacion-credifinanciera',
  'vinculacion-ibr-credifinanciera',
  'vinculacion-mundo-mujer',
  'vinculacion-banco-w',
  'vinculacion-mibanco',
  'vinculacion-coltefinanciera',
  'tripetto-tes',
  'widget-simulador',
  'referidos',
  'ab-testing',
  '404',
  'ab-testing/cdt-simulador',
  'login',
  'bloqueo-temporal',
  'te-contactaremos',
  'portal',
  // Funnels y páginas internas (match por prefijo: cubre todo lo que cuelga de ellas)
  'magical_experience',
  'pauta',
  'v2/preguntas-bancounion',
  'home-refactor',
  'sitemap',
];

/**
 * Indica si un path (con o sin slash inicial, sin query params) corresponde
 * a una ruta excluida de indexación. Soporta segmentos con parámetros (":id")
 * y hace match por PREFIJO de segmentos (misma semántica que Disallow en
 * robots.txt): 'portal' excluye '/portal', '/portal/login', '/portal/x/y', etc.
 */
export function isExcludedFromIndex(path: string): boolean {
  const cleanPath = path.replace(/^\/+/, '').split('?')[0];
  const pathSegments = cleanPath.split('/').filter(Boolean);

  return EXCLUDED_INDEX_ROUTES.some((route) => {
    const routeSegments = route.split('/').filter(Boolean);
    if (routeSegments.length > pathSegments.length) return false;

    return routeSegments.every(
      (segment, i) => segment.startsWith(':') || segment === pathSegments[i],
    );
  });
}
